export default [
  {
    path: '/order',
    component: () => import(/* webpackChunkName: "orderModule" */ '@views/order'),
    redirect: '/order/list/1',
    children: [
      // {
      //   path: '/order/list',
      //   redirect: '/order/list/1'
      // },
      {
        path: '/order/list/:type',
        component: () => import(/* webpackChunkName: "orderList" */ '@views/order/orderList'),
        name: 'orderList',
        meta: {
          isLogin: false,
          isFooterShow: true,
          title : '订单列表'
        }
      },
      {
        path: '/order/detail',
        component: () => import(/* webpackChunkName: "orderDetail" */ '@views/order/orderDetail'),
        name: 'orderDetail',
        meta: {
          isLogin: true,
          title : '预约单详情'
        }
      },
      {
        path: '/order/fill',
        component: () => import(/* webpackChunkName: "fillExpress" */ '@views/order/fillExpress'),
        name: 'fillExpress',
        meta: {
          isLogin: true,
          title : '填写快递'
        }
      },
      {
        path: '/order/onlineDetail',
        component: () => import(/* webpackChunkName: "onlineDetail" */ '@views/order/onlineDetail'),
        name: 'onlineDetail',
        meta: {
          isLogin: true,
          title : '服务详情'
        }
      },
      {
        path: '/order/diagnosis',
        component: () => import(/* webpackChunkName: "diagnosis" */ '@views/order/diagnosis'),
        name: 'diagnosis',
        meta: {
          isLogin: true,
          title : '诊断方案'
        }
      },
      {
        path: '/order/effects',
        component: () => import(/* webpackChunkName: "effects" */ '@views/order/effects'),
        name: 'effects',
        meta: {
          isLogin: true,
          title : '效果方案'
        }
      },
      {
        path: '/order/speedDetail',
        component: () => import(/* webpackChunkName: "speedDetail" */ '@views/order/speedDetail'),
        name: 'speedDetail',
        meta: {
          isLogin: true,
          title : '进度详情'
        }
      },
      {
        path: '/order/expressDetail',
        component: () => import(/* webpackChunkName: "expressDetail" */ '@views/order/expressDetail'),
        name: 'expressDetail',
        meta: {
          isLogin: true,
          title : '物流详情'
        }
      },
      //售后
      {
        path: '/order/after',
        component: () => import(/* webpackChunkName: "after" */ '@views/order/afterSale'),
        name: 'after',
        meta: {
          isLogin: true
        }
      },
      {
        path: '/order/place',
        component: () => import(/* webpackChunkName: "place" */ '@views/order/placeOrder'),
        name: 'place',
        meta: {
          isLogin: true,
          keepAlive: true,
          title : '一键下单'
        }
      },
      {
        path: '/order/bag',
        component: () => import(/* webpackChunkName: "shoppingBag" */ '@views/order/shoppingBag'),
        name: 'bag',
        meta: {
          isLogin: true,
          keepAlive: true,
          title : '购物车'
        }
      },
      {
        path: '/order/pay',
        component: () => import(/* webpackChunkName: "pay" */ '@views/order/pay'),
        name: 'pay',
        meta: {
          isLogin: true,
          title : '用户支付'
        }
      },
      {
        path: '/order/policy',
        component: () => import(/* webpackChunkName: "policy" */ '@views/order/policy'),
        name: 'policy',
        meta: {
          isLogin: false,
          title : '售后政策'
        }
      },
      {
        path: '/order/share',
        component: () => import(/* webpackChunkName: "share" */ '@views/order/share'),
        name: 'share',
        meta: {
          isLogin: false,
          title : '清仓分享'
        }
      },
      {
        path: '/order/paySuccess',
        component: () => import(/* webpackChunkName: "paySuc" */ '@views/order/paySuc'),
        name: 'paySuccess',
        meta: {
          isLogin: false,
          title : '支付成功'
        }
      },
      {
        path: '/order/statementsDetail',
        component: () => import(/* webpackChunkName: "paySuc" */ '@views/order/statementsDetail'),
        name: 'statementsDetail',
        meta: {
          isLogin: false,
          title : '结算详情'
        }
      },
      {
        path: '/order/evaluate',
        component: () => import(/* webpackChunkName: "paySuc" */ '@views/order/evaluate'),
        name: 'evaluate',
        meta: {
          isLogin: false,
          title : '评价'
        }
      },
      {
        path: '/order/programme',
        component: () => import(/* webpackChunkName: "paySuc" */ '@views/order/evaluate/programme'),
        name: 'programme',
        meta: {
          isLogin: false,
          title : '方案评价'
        }
      },
      {
        path: '/evaluate/success',
        component: () => import(/* webpackChunkName: "paySuc" */ '@views/order/evaluate/success'),
        name: 'evaluateSuccess',
        meta: {
          isLogin: false,
          title : '评价成功'
        }
      },
      {
        path: '/order/sendBack',
        component: () => import(/* webpackChunkName: "paySuc" */ '@views/order/evaluate/sendBack'),
        name: 'evaluateSendBack',
        meta: {
          isLogin: false,
          title : '寄回评价'
        }
      }
    ]
  }
]
